import FeatureTicker from "./feature-ticker";

const AVATAR_INITIALS = ["SM", "JT", "TH"];

const ValuePropPanel = () => {
  return (
    <div className="relative h-full min-h-screen bg-gradient-to-b from-[#e8fbfc] via-primary to-[#7de0e6] flex flex-col px-8 py-7 overflow-hidden select-none shadow-[4px_0_32px_rgba(0,0,0,0.10)]">
      {/* Decorative blobs — teal/cyan tints only, no purple, stays within the hue family */}
      <div
        aria-hidden="true"
        className="absolute -top-5 -right-5 w-52 h-52 rounded-full bg-[rgba(0,180,200,0.18)] blur-[80px] pointer-events-none"
      />
      <div
        aria-hidden="true"
        className="absolute -bottom-5 -left-5 w-44 h-44 rounded-full bg-[rgba(0,160,185,0.14)] blur-[60px] pointer-events-none"
      />

      {/* Logo — natural colours on light background */}
      <div className="relative z-10 mb-5">
        <img src="/logo-name.png" alt="NirvaScribe" className="h-9" />
      </div>

      {/* Ticker */}
      <div className="relative z-10 mb-8">
        <FeatureTicker dark={false} />
      </div>

      {/* Push trust row to lower half */}
      <div className="flex-1" />

      {/* Headline + subheading */}
      <div className="relative z-10 mb-4">
        <h1 className="text-[32px] font-bold text-gray-900 leading-[1.15] mb-2 font-dm-sans">
          Focus on Care,
          <br />
          Not Paperwork.
        </h1>
        <p className="text-[13px] text-gray-600 leading-relaxed">
          AI-powered clinical documentation for
          <br />
          Australian healthcare professionals.
        </p>
      </div>

      {/* Trust row — between headline and testimonial */}
      <div className="relative z-10 mb-4">
        <div className="flex items-center gap-2.5">
          <div className="flex -space-x-2">
            {AVATAR_INITIALS.map((initials, i) => (
              <div
                key={i}
                className="w-7 h-7 rounded-full bg-white/70 border-2 border-[#7de0e6] flex items-center justify-center text-[9px] text-gray-800 font-semibold shrink-0"
              >
                {initials}
              </div>
            ))}
          </div>
          <span className="text-xs text-gray-600">Trusted by Aussie clinicians</span>
        </div>
      </div>

      {/* Testimonial card */}
      <div className="relative z-10 bg-white/60 backdrop-blur-sm border border-gray-200/80 rounded-[9px] p-[14px]">
        <p className="text-[13px] text-gray-800 leading-[1.55] mb-3">
          "NirvaScribe has been a genuine time saver. The templates are flexible,
          and the scribe does a great job capturing what matters clinically."
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-[26px] h-[26px] rounded-full bg-[#7de0e6] flex items-center justify-center text-[9px] text-gray-800 font-semibold shrink-0">
              TH
            </div>
            <div>
              <p className="text-xs font-bold text-gray-900 leading-tight">
                Thashmi H.
              </p>
              <p className="text-[11px] text-gray-500 leading-tight">
                Audiologist · Melbourne
              </p>
            </div>
          </div>
          <span className="text-yellow-500 text-sm tracking-tight" aria-label="5 stars">
            ★★★★★
          </span>
        </div>
      </div>
    </div>
  );
};

export default ValuePropPanel;
